import { Icon } from '@/kit/Icon';
import { DialogActions, DialogClose, DialogContent, type DialogComponentProps } from '@/kit/dialog';

export interface ConfirmPopupData {
  title: string;
  message: string;
}

/** A yes / no confirmation for an action that rebuilds or replaces something. Resolves true (Yes), false (No) or undefined. */
export function ConfirmPopup({ data }: DialogComponentProps<ConfirmPopupData, boolean>) {
  return (
    <div className="mat-dialog-wrapper">
      <DialogContent>
        <div className="main-contain">
          <div className="sidenav-header">
            <div className="d-flex align-items-center justify-space-between">
              <h2>
                <span>{data?.title ?? 'Confirm'}</span>
              </h2>
              <DialogClose>
                <Icon name="close" className="close" />
              </DialogClose>
            </div>
          </div>
        </div>
        <p className="font-size-14">{data?.message}</p>
      </DialogContent>
      <DialogActions>
        <div className="d-flex gap-15">
          <DialogClose as="button" result={true} type="button" className="action-button primary-button">
            OK
          </DialogClose>
          <DialogClose as="button" result={false} type="button" className="action-button secondary-button">
            Cancel
          </DialogClose>
        </div>
      </DialogActions>
    </div>
  );
}
